const LangList1 =  {
    /*"zh": "中文 ",
    "jp": "にほんご",
    "ara": "بالعربية ",
    "en": "English ",
    "spa": "Español ",
    "it": "Italiano ",
    "de": "Deutsch ",
    "pt": "Português ",
    "fra": "Français",
    "nl": "Nederlands",
    "id": "Indonesia",
    "hi": "हिंदी भाषा",
    "kor": "한국어",
    "tr": "Türkçe",
    "swe": "Svenska språket",
    "ga": "Íris",
    "ru": "Русский язык",
    "vie": "Tiếng Việt",
    "th": "ภาษาไทย",
    est: "Eesti keel",
    be: "Беларуская мова",
    bul: "Български",
    pl: "Język polski",
    ms: "Bahasa Malay",*/


    "jp": "にほんご",
    "en": "English ",
    "kor": "한국어"
};

export default LangList1